import { render, staticRenderFns } from "./DraftCard.vue?vue&type=template&id=4ecedec4&scoped=true&"
import script from "./DraftCard.vue?vue&type=script&lang=js&"
export * from "./DraftCard.vue?vue&type=script&lang=js&"
import style0 from "./DraftCard.vue?vue&type=style&index=0&id=4ecedec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecedec4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VFadeTransition,VForm,VHover,VIcon,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ecedec4')) {
      api.createRecord('4ecedec4', component.options)
    } else {
      api.reload('4ecedec4', component.options)
    }
    module.hot.accept("./DraftCard.vue?vue&type=template&id=4ecedec4&scoped=true&", function () {
      api.rerender('4ecedec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/DraftCard.vue"
export default component.exports